import utils from '@/components/tools/utils'

class EavFormatter {
  constructor (store, i18n) {
    this.store = store
    this.i18n = i18n
  }

  withUnit (attributeCode, value) {
    let isNl = false
    try {
      const { locale } = this.i18n
      if (locale.startsWith('nl')) {
        isNl = true
      }
    } catch (e) {
    }

    switch (attributeCode) {
      case 'mileage':
      case 'trailer_mileage':
      case 'mileage_last_service':
      case 'trailer_mileage_last_service':
      case 'mileage_last_inspection':
      case 'mileage_cambelt_replaced':
        return value + ' km'
      case 'engine_capacity_select':
      case 'engine_capacity':
        return value + ' cm³'
      case 'licensed_weight':
      case 'trailer_licensed_weight':
      case 'trailer_empty_weight':
        return value + ' kg'
      case 'power_select': {
        if (value === 'Andere' || value === 'Unbekannt') {
          return value
        }

        const ps = utils.kwToPs(value)
        if (Number.isNaN(ps)) {
          return value
        } else {
          if (isNl) {
            return value + ' kW (' + ps + ' PK)'
          }

          return value + ' kW (' + ps + ' PS)'
        }
      }
      case 'power': {
        if (value === 'Andere' || value === 'Unbekannt') {
          return value
        }

        const ps = utils.kwToPs(value)
        if (Number.isNaN(ps)) {
          if (isNl) {
            return value + ' kW (0 PK)'
          }

          return value + ' kW (0 PS)'
        } else {
          if (isNl) {
            return value + ' kW (' + ps + ' PK)'
          }

          return value + ' kW (' + ps + ' PS)'
        }
      }
      case 'length':
      case 'trailer_length':
        return value + ' mm'
      case 'width':
      case 'trailer_width':
        return value + ' mm'
      case 'height':
      case 'trailer_height':
      case 'trailer_height_inner':
        return value + ' mm'
      default:
        return value
    }
  }

  withI18n (attributeCode, value) {
    let ps = 0
    if (attributeCode === 'power') {
      const val = utils.kwToPs(value)
      if (!Number.isNaN(val)) {
        ps = val
      }
    }
    return this.i18n.t('attributes.' + attributeCode, {
      value,
      ps
    })
  }

  formatValue (attributeCode, backendType, value) {
    if (backendType === 'int' || backendType === 'decimal') {
      value = utils.formatNumber(value)
    } else if (backendType === 'datetime') {
      value = utils.formatDateMini(value)
    }

    return this.withUnit(attributeCode, value)
  }

  format (attributeCode, backendType, value) {
    value = this.formatValue(attributeCode, backendType, value)

    return this.withI18n(attributeCode, value)
  }

  formatUploadAttribute (attributeCode, value) {
    if (attributeCode in this.store?.state?.upload?.attributes) {
      const attribute = this.store?.state?.upload?.attributes[attributeCode]
      value = this.formatAttribute(attribute, value)
    }
    return value
  }

  formatAttribute (attribute, value) {
    if (attribute.frontendInput === 'simple' && attribute.backendType === 'int') {
      value = utils.formatNumber(value)
    } else if (attribute.frontendInput === 'simple' && attribute.backendType === 'datetime') {
      value = utils.formatDateMini(value)
    } else if (attribute.frontendInput === 'select' && attribute.backendType === 'int') {
      const found = attribute.options.find(o => o.optionId === value.optionId)
      if (found) {
        value = found.label
      }
    } else if (attribute.frontendInput === 'multipleselect' && attribute.backendType === 'varchar') {
      value = value.map((v) => {
        const found = attribute.options.find(a => a.optionId === v.optionId)
        if (found) {
          return found.label
        } else {
          return ''
        }
      }).join(', ')
    }

    return this.withUnit(attribute.attributeCode, value)
  }

  findAndFormatAttribute (attributeCode, frontendInput, attributes) {
    if (!attributes) {
      return '-'
    }

    const found = attributes[frontendInput + 's']?.find(attribute => attribute.attributeCode === attributeCode)
    if (found) {
      return this.formatUploadAttribute(attributeCode, found.value)
    } else {
      return '-'
    }
  }

  findAndFormatAndLabelAttribute (attributeCode, frontendInput, attributes) {
    const value = this.findAndFormatAttribute(attributeCode, frontendInput, attributes)

    return this.withI18n(attributeCode, value)
  }
}

export default function ({
  $axios,
  $config,
  store,
  i18n
}, inject) {
  inject('eavFormatter', new EavFormatter(store, i18n))
}
